export default "__VITE_ASSET__BkZoaL$X__"